import { Component, EventEmitter, Output } from '@angular/core';

import { TranslationKeyMap } from '../../coaching-insight.i18n';

@Component({
    selector: '[cmpsSelectOptionCalendar]',
    template: `
        <div class="soc-container">
            <div class="spr-row">
                <button
                    (click)="updateEventChange.emit()"
                    class="btn bg-transparent p-0 soc-wrapper"
                >
                    <cmps-icon svgIcon="pencil"></cmps-icon>
                    {{ _i18n._9679_UPDATE_EVENT | translate }}
                </button>
            </div>
            <div class="spr-row">
                <button
                    (click)="cancelEventChange.emit()"
                    class="btn bg-transparent p-0 soc-wrapper"
                >
                    <cmps-icon svgIcon="delete"></cmps-icon>
                    {{ _i18n._9680_CANCEL_EVENT | translate }}
                </button>
            </div>
        </div>
    `,
})
export class SelectOptionCalendarComponent {
    @Output() updateEventChange: EventEmitter<any>;
    @Output() cancelEventChange: EventEmitter<any>;

    /** @private */ _i18n = TranslationKeyMap;

    constructor() {
        this.updateEventChange = new EventEmitter();
        this.cancelEventChange = new EventEmitter();
    }
}
